import { slice, tail } from 'es-toolkit/compat';

import { HistoryState } from 'types';
import AppConstants from 'constants/AppConstants';

const initialState: HistoryState = {
  locationHistory: [],
};

export default function reducer(
  state: HistoryState = initialState,
  action: BaseTockAction
): HistoryState {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.HISTORY_LOCATION_PUSH: {
      // Max out our history tracking at 300
      const locationHistory = slice([payload, ...state.locationHistory], 0, 300);
      return {
        ...state,
        locationHistory,
      };
    }
    case AppConstants.HISTORY_LOCATION_REPLACE: {
      const locationHistory = [payload, ...tail(state.locationHistory)];
      return {
        ...state,
        locationHistory,
      };
    }
    case AppConstants.HISTORY_LOCATION_BACK: {
      const locationHistory = tail(state.locationHistory);
      return {
        ...state,
        locationHistory,
      };
    }
    default:
      return state;
  }
}
